export default __webpack_public_path__ + "static/media/womanExclamation.cb7d83ba.svg";